import styled from '@emotion/styled';
import {
  Button,
  SvgIcon,
  SvgNames,
  Textarea,
  tokens,
  Typography,
} from '@sunrun/experience-ui-components';
import { useState } from 'react';
import CurrentLogo from 'assets/images/current.svg';
import { Mixpanel } from 'providers/Mixpanel';
import { DASHBOARD_OVERVIEW__CLICKED_ON_CURRENT_AI_WITH_QUESTION } from 'constants/mixpanelEvents';

const CURRENT_URL = 'https://current.sunrun.com/';

const UserGuidesTutorialsWidget = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const generateCurrentUrl = (term: string) => {
    const encodedTerm = encodeURIComponent('How do I ' + term + ' in ONE?');
    return `${CURRENT_URL}search?term=${encodedTerm}`;
  };

  const handleCurrentQuestion = (question: string = '') => {
    const url = question ? generateCurrentUrl(question.trim()) : CURRENT_URL;
    Mixpanel.track(DASHBOARD_OVERVIEW__CLICKED_ON_CURRENT_AI_WITH_QUESTION, {
      searchTerm: question,
    });
    window.open(url, '_blank');
  };

  return (
    <Container>
      <CurrentWordmark src={CurrentLogo} alt="Current" />
      <MaxWidthTypography>
        See ONE user guides and tutorials in Current or use AI answer to get
        your answers
      </MaxWidthTypography>
      <div>
        <Typography size="large">
          How do I <Underline /> in ONE?
        </Typography>
        <Textarea
          placeholder="Enter your question about One here"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <Button
          size="sm"
          color="secondary"
          onClick={() => handleCurrentQuestion(searchTerm)}>
          See AI answer in Current {'  '}
          <SvgIcon
            name={SvgNames.ExternalLink}
            height={20}
            width={20}
            color={tokens.BRAND_HERO_BLUE}
          />
        </Button>
      </div>
    </Container>
  );
};

const MaxWidthTypography = styled(Typography)`
  max-width: 90%;
`;

const CurrentWordmark = styled.img`
  display: block;
  width: 240px;
  max-width: 75%;
`;

const Underline = styled.span`
  width: 60px;
  border-bottom: 1px solid ${tokens.BRAND_HERO_BLUE};
  display: inline-block;
  height: 10px;
  position: relative;
  top: 2px;
  margin: 0 6px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 14px;
`;

export { UserGuidesTutorialsWidget };
